export const getRequestView = (item) => {
  const status = String(item?.status || "").trim().toLowerCase();
  if (status.includes("return to inventory")) return "returns";
  if (status.includes("for issue")) return "issuances";
  if (status === "for disposal" || status === "disposed") return "disposals";
  const stage = String(item?.requeststatus || "").trim().toLowerCase();
  const transfer = item?.transfered_to_id || item?.transferedto_id ||
    item?.transferred_to_id || item?.transfered_to || item?.transferedto ||
    item?.transferred_to || item?.transfer_type || item?.transferType || item?.transfer_mode;
  if (status === "for transfer" ||
      (transfer && ["for approval", "for release", "to receive"].includes(stage))) return "transfers";
  return null;
};

// Badges need all matching records, not just the first visible page.
export const fetchRequestPages = async (url, params, signal) => {
  const query = new URLSearchParams(params);
  query.set("limit", "200");
  const records = [];
  for (let page = 1; ; page += 1) {
    query.set("page", String(page));
    const response = await fetch(`${url}?${query}`, { credentials: "include", signal });
    if (!response.ok) throw new Error(`Unable to load requests (${response.status}).`);
    const payload = await response.json();
    if (Array.isArray(payload)) return payload;
    if (!Array.isArray(payload?.data) || !Number.isFinite(Number(payload.total))) {
      throw new Error("Invalid request list response.");
    }
    records.push(...payload.data);
    if (records.length >= Number(payload.total)) break;
    if (!payload.data.length) throw new Error("Request list changed while loading. Please refresh.");
  }
  const unique = new Map(records.map(row => [`${row.category || ""}:${row._id}`, row]));
  return [...unique.values()];
};
